"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../../config/types");
const onchainAccountPoolToken_1 = __importDefault(require("../onchainAccountPoolToken"));
class OnchainAccountBorrowable extends onchainAccountPoolToken_1.default {
    constructor(lendingPool, poolTokenType) {
        super();
        this.borrowableCache = {};
        this.getLendingPool = () => this.lendingPool;
        this.getPoolToken = () => this.poolToken;
        this.getAccount = () => this.lendingPool.getAccount();
        this.getInteractionsBorrowable = this.getInteractionsPoolToken;
        this.getOffchainAccountBorrowable = this.getOffchainAccountPoolToken;
        // Shortcuts
        this.getPoolTokenType = () => this.poolToken.getPoolTokenType();
        this.getSupplyAPR = () => __awaiter(this, void 0, void 0, function* () { return (yield this.poolToken.getOffchainPoolToken()).getSupplyAPR(); });
        this.getBorrowRate = () => __awaiter(this, void 0, void 0, function* () { return (yield this.poolToken.getOffchainPoolToken()).getBorrowRate(); });
        this.getAccrualTimestamp = () => __awaiter(this, void 0, void 0, function* () { return (yield this.poolToken.getOffchainPoolToken()).getAccrualTimestamp(); });
        this.lendingPool = lendingPool;
        this.poolToken = lendingPool.getLendingPool().getPoolToken(poolTokenType);
    }
    getInteractionsPoolToken() {
        return this.lendingPool.getInteractionsLendingPool().getPoolToken(this.getPoolTokenType());
    }
    getOffchainAccountPoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const offchainAccountLendingPool = yield this.lendingPool.getOffchainAccountLendingPool();
            return offchainAccountLendingPool.getPoolToken(this.getPoolTokenType());
        });
    }
    cleanCache() {
        super.cleanCache();
        this.borrowableCache = {};
    }
    // Borrowed
    initializeBorrowed() {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowable = yield this.poolToken.getPoolToken();
            const balance = yield borrowable.methods.borrowBalance(this.getAccountAddress()).call();
            const storedAmount = yield yield this.poolToken.normalize(balance);
            const accrualTimestamp = yield this.getAccrualTimestamp();
            const borrowRate = yield this.getBorrowRate();
            return storedAmount * (1 + (Date.now() / 1000 - accrualTimestamp) * borrowRate);
        });
    }
    getBorrowed() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.borrowableCache.borrowed)
                this.borrowableCache.borrowed = this.initializeBorrowed();
            return this.borrowableCache.borrowed;
        });
    }
    getBorrowedUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowed = yield this.getBorrowed();
            const tokenPrice = yield this.getTokenPriceAccurate();
            return borrowed * tokenPrice;
        });
    }
    // Max OffchainBorrowable
    /*public async getMaxBorrowable() : Promise<number> {
      const availableCash = await this.poolToken.getTotalBalance();
      const { valueCollateral, valueA, valueB } = await this.lendingPool.getValues(NO_CHANGES);
      const [valueBorrowed, valueOther] = this.getPoolTokenType() == PoolTokenType.BorrowableA ? [valueA, valueB] : [valueB, valueA];
      const safetyMargin = (await this.lendingPool.getSafetyMargin()) * this.getUiMargin();
      const liquidationPenalty = await this.lendingPool.getLiquidationPenalty();
      const actualCollateral = valueCollateral / liquidationPenalty;
      const totalValueBorrowable1 = (actualCollateral * Math.sqrt(safetyMargin) - valueOther) / safetyMargin;
      const totalValueBorrowable2 = (actualCollateral / Math.sqrt(safetyMargin) - valueOther) * safetyMargin;
      const maxValueBorrowable = Math.min(totalValueBorrowable1, totalValueBorrowable2) - valueBorrowed;
      const price = await this.poolToken.getMarketPriceDenomLP();
      return Math.max(0, Math.min(availableCash, maxValueBorrowable / price));
    }*/
    // binary search approach
    getMaxBorrowable() {
        return __awaiter(this, void 0, void 0, function* () {
            const availableCash = yield this.poolToken.getTotalBalance();
            const twapPrice = yield this.lendingPool.getLendingPool().getTWAPPrice();
            // start search
            let borrowAmount = availableCash;
            let borrowAmountPrev = 0;
            let bestAmount = 0;
            for (let i = 0; i < 1000; i++) {
                const jump = Math.abs(borrowAmount - borrowAmountPrev) / 2;
                if (jump / availableCash < 1e-9)
                    break;
                borrowAmountPrev = borrowAmount;
                const changeCollateral = 0;
                const changeBorrowedA = this.getPoolTokenType() == types_1.PoolTokenType.BorrowableA ? borrowAmount : 0;
                const changeBorrowedB = this.getPoolTokenType() == types_1.PoolTokenType.BorrowableB ? borrowAmount : 0;
                const changes = { changeCollateral, changeBorrowedA, changeBorrowedB };
                const [liqPriceA, liqPriceB] = yield this.lendingPool.getLiquidationPrices(changes);
                if (liqPriceA * this.getUiMargin() > twapPrice || liqPriceB / this.getUiMargin() < twapPrice)
                    borrowAmount -= jump;
                else {
                    bestAmount = borrowAmount;
                    borrowAmount += jump;
                }
            }
            bestAmount = bestAmount > availableCash ? availableCash : bestAmount;
            return bestAmount;
        });
    }
    // Farming Shares
    initializeFarmingShares() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.poolToken.hasImpermaxChef()))
                return 0;
            return (yield this.poolToken.getImpermaxChef().methods.userInfo(yield this.poolToken.getPoolTokenAddress(), this.getAccountAddress()).call()).shares;
        });
    }
    getFarmingShares() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.borrowableCache.farmingShares)
                this.borrowableCache.farmingShares = this.initializeFarmingShares();
            return this.borrowableCache.farmingShares;
        });
    }
    // Available Reward
    initializeAvailableFarmingReward() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.poolToken.hasImpermaxChef()))
                return 0;
            const borrowableAddress = yield this.poolToken.getPoolTokenAddress();
            try {
                return (yield this.poolToken.getImpermaxChef().methods.pendingReward(borrowableAddress, this.getAccountAddress()).call()) / 1e18;
            }
            catch (_a) {
                console.log("Warning: pending reward negative");
                return 0;
            }
        });
    }
    getAvailableFarmingReward() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.borrowableCache.availableFarmingReward)
                this.borrowableCache.availableFarmingReward = this.initializeAvailableFarmingReward();
            return this.borrowableCache.availableFarmingReward;
        });
    }
    initializeAvailableRewarderReward() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!(yield this.poolToken.hasRewarder()))
                return 0;
            const borrowableAddress = yield this.poolToken.getPoolTokenAddress();
            const rewarder = yield this.poolToken.getRewarder();
            try {
                return (yield rewarder.methods.pendingReward(borrowableAddress, this.getAccountAddress()).call()) / 1e18;
            }
            catch (_a) {
                console.log("Warning: pending reward negative");
                return 0;
            }
        });
    }
    getAvailableRewarderReward() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.borrowableCache.availableRewarderReward)
                this.borrowableCache.availableRewarderReward = this.initializeAvailableRewarderReward();
            return this.borrowableCache.availableRewarderReward;
        });
    }
}
exports.default = OnchainAccountBorrowable;
